import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslation from './locales/en/translation.json';
import neTranslation from './locales/ne/translation.json';

const resources = {
  en: {
    translation: enTranslation
  },
  ne: {
    translation: neTranslation
  }
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: false, // Set to true for debugging
    
    interpolation: {
      escapeValue: false // React already escapes values
    },

    detection: {
      // Order of language detection
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Keys to lookup language from
      lookupLocalStorage: 'i18nextLng',
      // Cache user language
      caches: ['localStorage'],
    },

    react: {
      useSuspense: true
    }
  });

// Update document attributes when language changes
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  document.body.setAttribute('data-lang', lng);
  
  // Update document title based on language
  const baseTitle = lng === 'ne' ? 'रा. स्व. पा. कोष संकलन' : 'RSP Fundraiser';
  document.title = baseTitle;
});

// Set initial language attributes
if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language;
  document.body.setAttribute('data-lang', i18n.language);
}

export default i18n;
